import { render, staticRenderFns } from "./listAllCourse.vue?vue&type=template&id=45f35e38&"
import script from "./listAllCourse.vue?vue&type=script&lang=js&"
export * from "./listAllCourse.vue?vue&type=script&lang=js&"
import style0 from "./listAllCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports